import React from 'react';
import { ChartsCard } from 'pg-ui-library';
import { Container } from './styles';

export const ChartItem: React.FC<{
  chartData: { name: string; value: number; color: string }[];
  title: string;
}> = ({ chartData, title }) => (
  <Container>
    <h3>{title}</h3>
    <ChartsCard data={chartData} />
  </Container>
);
